import Colors from '../../../../../constants/Colors';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    height: 'auto', 
    width: '35%', 
    maxWidth: '45%', 
  },
  title: {
    marginTop: 28,
    fontSize: 14,
    fontWeight: '700',
    color: Colors.darkText,
  },
};
